import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import Loading from "./loader";
import { enqueueSnackbar } from 'notistack';
import { Tooltip, Descriptions, Menu, Typography } from "antd";
import {
  SyncOutlined,
  FolderOpenOutlined,
  FileDoneOutlined,
  BarChartOutlined,
  VideoCameraOutlined,
  ArrowLeftOutlined,
  CheckSquareOutlined,
  PicLeftOutlined,
  CaretRightOutlined
} from "@ant-design/icons";

class VoteExtended extends Component {
  state = {
    meetings: null,
    issuer: null,
    registrar: null,
    registered: {}, // оставлено для UX
    hasVoted: false,
    selectedAccountId: null,
    selectedUniquifier: null,
    accountFullname: '',
    isMultiplePacs: false
  };

  async checkAccessVote(meetingId, accountId, uniquifier) {
    const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
    const accessVoteRes = await fetch(`${API_ADDRESS}get_access_vote/${meetingId}/${accountId}/${uniquifier}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (accessVoteRes.ok) {
      const accessVoteData = await accessVoteRes.json();
      return accessVoteData.exists;
    } else {
      console.error('Ошибка при получении доступа к голосованию:', accessVoteRes.statusText);
      return false;
    }
  }

  async checkRegistrationStatus(meetingId, accountId, uniquifier) {
    const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
    const res = await fetch(`${API_ADDRESS}reg_status/${meetingId}/${accountId}/${uniquifier}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    if (res.ok) {
      const data = await res.json();
      return data.is_registered;
    }
    return false;
  }

  async componentDidMount() {
    const { match } = this.props;
    const meetingId = match.params.meetingId;
    const selectedAccountId = match.params.selectedAccountId;
    const selectedUniquifier = match.params.selectedUniquifier;

    this.setState({ selectedAccountId, selectedUniquifier });

    const accountFullname = localStorage.getItem(`selectedAccountFullname_${meetingId}_${selectedAccountId}_${selectedUniquifier}`) || '';
    const isMultiplePacs = localStorage.getItem(`isMultiplePacs_${meetingId}_${selectedAccountId}_${selectedUniquifier}`) === 'true';
    this.setState({ accountFullname, isMultiplePacs });

    try {
      const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
      const meetingRes = await fetch(`${API_ADDRESS}get_meeting/${meetingId}/${selectedAccountId}/${selectedUniquifier}/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (meetingRes.ok) {
        const meetingData = await meetingRes.json();
        const { meeting, issuer, registrar } = meetingData;
        this.setState({
          meetings: meeting,
          issuer: issuer,
          registrar: registrar
        });
        this.checkMeetingEnd(meeting.meeting_close);
      } else {
        alert("Произошла ошибка. Попробуйте еще раз выбрать голосование.");
        window.history.back();
        console.error('Ошибка:', meetingRes.statusText);
      }

      if (meetingRes.statusText === "Unauthorized") {
        alert("Время сессии истекло. Пожалуйста выполните вход.");
        document.getElementById("logoutBttn").click();
      }
    } catch (e) {
      alert("Произошла ошибка. Попробуйте еще раз выбрать голосование.");
      window.history.back();
      console.log(e);
    }
  }

  checkMeetingEnd = (meetingCloseTime) => {
    const closeoutTime = new Date(meetingCloseTime);
    const intervalId = setInterval(() => {
      const currentTime = new Date();
      if (currentTime >= closeoutTime) {
        const { meetings, selectedAccountId, selectedUniquifier } = this.state;
        const meetingId = meetings?.meeting_id;
        if (meetingId && selectedAccountId && selectedUniquifier) {
          this.setState((prevState) => {
            const updatedRegistered = { ...prevState.registered };
            delete updatedRegistered[`${meetingId}_${selectedAccountId}_${selectedUniquifier}`];
            return { registered: updatedRegistered };
          });
        }
        clearInterval(intervalId);
      }
    }, 1000);
  };

  async regSave() {
    const { meetings, selectedAccountId, selectedUniquifier } = this.state;
    const meeting_id = meetings.meeting_id;
    const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;

    const userRes = await fetch(
      `${API_ADDRESS}reg_save/${meeting_id}/${selectedAccountId}/${selectedUniquifier}/`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
  }

  async getServerTime() {
    const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
    const response = await fetch(`${API_ADDRESS}get_server_time/`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      return new Date(data.server_time);
    } else {
      console.error('Ошибка при получении серверного времени');
      return null;
    }
  }

  handleRegisterActive = async () => {
    const { meetings, selectedAccountId, selectedUniquifier } = this.state;
    const serverTime = await this.getServerTime();
    const meetingId = meetings.meeting_id;

    const checkinTime = new Date(meetings.checkin);
    const closeoutTime = new Date(meetings.closeout);

    const hasVotedCheck = await this.checkAccessVote(meetingId, selectedAccountId, selectedUniquifier);
    this.setState({ hasVoted: hasVotedCheck });

    const isRegistered = await this.checkRegistrationStatus(meetingId, selectedAccountId, selectedUniquifier);

    if (hasVotedCheck) {
      enqueueSnackbar('Регистрация недоступна. Вы уже проголосовали', { variant: 'error' });
      return false;
    }

    if (isRegistered) {
      enqueueSnackbar('Вы уже зарегистрированы!', { variant: 'warning' });
      return false;
    }

    if (serverTime >= checkinTime && serverTime <= closeoutTime && meetings.status === 2) {
      this.setState(prevState => ({
        registered: { ...prevState.registered, [`${meetingId}_${selectedAccountId}_${selectedUniquifier}`]: true }
      }));
      enqueueSnackbar('Вы успешно зарегистрировались!', { variant: 'success' });
      this.regSave();
    } else if (selectedAccountId === null) {
      enqueueSnackbar('Неожиданная ошибка, попробуйте позже', { variant: 'error' });
      return false;
    } else {
      enqueueSnackbar('Регистрация недоступна. Проверьте время начала регистрации', { variant: 'error' });
      return false;
    }
  };

  handleActivateVote = async () => {
    const { meetings, selectedAccountId, selectedUniquifier } = this.state;
    const serverTime = await this.getServerTime();

    if (!meetings || !selectedAccountId || !selectedUniquifier) {
      enqueueSnackbar('Не выбрано собрание или аккаунт.', { variant: 'error' });
      return;
    }

    const meetingId = meetings.meeting_id;
    const meetingOpenTime = new Date(meetings.meeting_open);
    const meetingCloseTime = new Date(meetings.meeting_close);
    const meetingDate = new Date(meetings.meeting_date);

    const isRegistered = await this.checkRegistrationStatus(meetingId, selectedAccountId, selectedUniquifier);
    const hasVotedCheck = await this.checkAccessVote(meetingId, selectedAccountId, selectedUniquifier);

    if (!isRegistered) {
      if (hasVotedCheck) {
        enqueueSnackbar('Вы уже проголосовали', { variant: 'error' });
        return false;
      } else {
        enqueueSnackbar('Вы не зарегистрированы для голосования!', { variant: 'warning' });
        return false;
      }
    }

    const isSameDate = (date1, date2) => {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    };

    const serverDateOnly = new Date(serverTime);
    const meetingDateOnly = new Date(meetingDate);
    serverDateOnly.setHours(0, 0, 0, 0);
    meetingDateOnly.setHours(0, 0, 0, 0);
    const isSameMeetingDate = isSameDate(serverDateOnly, meetingDateOnly);

    if (
      serverTime >= meetingOpenTime &&
      serverTime <= meetingCloseTime &&
      meetings.status === 3 &&
      isSameMeetingDate
    ) {
      if (hasVotedCheck) {
        enqueueSnackbar('Вы уже проголосовали', { variant: 'error' });
        return false;
      }

      this.props.history.push(`/voteActive/${meetingId}/${selectedAccountId}/${selectedUniquifier}`);
      return true;
    } else {
      enqueueSnackbar('Голосование недоступно. Проверьте дату или время начала голосования', { variant: 'error' });
      return false;
    }
  };

  resultVoteClick = () => {
    const { meetings, selectedAccountId, selectedUniquifier } = this.state;
    const meetingId = meetings.meeting_id;
    this.props.history.push(`/voteOneResult/${meetingId}/${selectedAccountId}/${selectedUniquifier}`);
  };

  handleStreamClick = () => {
    const { meetings } = this.state;
    const meetingId = meetings.meeting_id;
    this.props.history.push(`/voteStream/${meetingId}`);
  };

  handleDocsClick = () => {
    const { meetings } = this.state;
    const meetingId = meetings.meeting_id;
    this.props.history.push(`/voteDocs/${meetingId}`);
  };

  handleResultsClick = () => {
    const { meetings } = this.state;
    const meetingId = meetings.meeting_id;
    this.props.history.push(`/voteResults/${meetingId}`);
  };

  handleBackClick = () => {
    this.props.history.push("/");
  };

  render() {
    const { meetings, issuer, registrar } = this.state;
    const { Text } = Typography;

    if (!meetings || !issuer || !registrar) {
      return <Loading />;
    }

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      };
      return new Intl.DateTimeFormat('ru-RU', options).format(date);
    };

    const formatDateOnly = (dateString) => {
      const [year, month, day] = dateString.split('-');
      return `${day}.${month}.${year}`;
    };

    const getStatusText = (status) => {
      const map = {
        1: 'Ожидается',
        2: 'Разрешена регистрация',
        3: 'Разрешено голосование',
        4: 'Голосование завершено',
        5: 'Собрание завершилось'
      };
      return map[status] || 'Неизвестно';
    };

    const getStatusColor = (status) => {
      switch (status) {
        case 2: return '#faad14';
        case 3: return '#52c41a';
        case 4: return '#f5222d';
        default: return '#d9d9d9';
      }
    };

    const {
      annual_or_unscheduled,
      inter_or_extra_mural,
      meeting_date,
      meeting_location,
      meeting_name,
      meeting_open,
      decision_date,
      deadline_date,
      protocol_date,
      record_date,
      checkin,
      vote_counting,
      status,
    } = meetings;

    return (
      <>
        <div className="page-container">
          <div className="header-container">
            <div className="header-with-pac" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '16px',
              width: '100%'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                <div className="back-button-wrapper" onClick={this.handleBackClick}>
                  <ArrowLeftOutlined
                    style={{ fontSize: '20px', cursor: 'pointer', marginTop: '4px' }}
                  />
                </div>
                <h1>Описание собрания</h1>
              </div>

              {this.state.isMultiplePacs && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  color: '#555',
                  fontSize: '1em',
                  marginTop: '-10px'
                }}>
                  <span>
                    Выбран пакет голосов: <b>{this.state.accountFullname}</b>
                  </span>
                  <Tooltip title="Сменить пакет голосов" placement="right">
                    <SyncOutlined
                      style={{
                        fontSize: '16px',
                        color: '#1890ff',
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        const { match } = this.props;
                        const meetingId = match.params.meetingId;
                        const selectedAccountId = match.params.selectedAccountId;

                        localStorage.removeItem(`selectedAccountFullname_${meetingId}_${selectedAccountId}_${this.state.selectedUniquifier}`);
                        localStorage.removeItem(`isMultiplePacs_${meetingId}_${selectedAccountId}_${this.state.selectedUniquifier}`);

                        const meetings = JSON.parse(localStorage.getItem('meetings') || '[]');
                        const selectedIndex = meetings.findIndex(m => m.meeting_id === parseInt(meetingId));
                        if (selectedIndex !== -1) {
                          localStorage.setItem('restoreSelectedIndex', selectedIndex);
                        }

                        this.props.history.push(`/`);
                      }}
                    />
                  </Tooltip>
                </div>
              )}
            </div>
          </div>

          <div style={{
            width: '60%',
            maxWidth: '70%',
            margin: '10px auto',
            display: 'flex',
            gap: '20px',
            alignItems: 'flex-start'
          }}>
            <div style={{
              minWidth: '180px',
              position: 'sticky',
              top: '120px',
              alignSelf: 'flex-start',
              zIndex: 1,
            }}>
              <Menu
                mode="inline"
                style={{
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  marginBottom: '16px',
                  overflow: 'visible'
                }}
              >
                <Menu.Item
                  key="register"
                  icon={<CheckSquareOutlined />}
                  className="menu-item-color"
                  onClick={this.handleRegisterActive}
                >
                  Регистрация
                </Menu.Item>
              </Menu>

              <Menu
                mode="inline"
                style={{
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  marginBottom: '16px',
                  overflow: 'visible'
                }}
              >
                <Menu.Item
                  key="vote"
                  icon={<PicLeftOutlined />}
                  className="menu-item-color"
                  onClick={this.handleActivateVote}
                >
                  Голосование
                </Menu.Item>
              </Menu>

              <Menu
                mode="inline"
                style={{
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  overflow: 'visible'
                }}
              >
                <Menu.Item key="docs" icon={<FolderOpenOutlined />} onClick={this.handleDocsClick}>
                  Материалы
                </Menu.Item>

                <Menu.Item key="results" icon={<FileDoneOutlined />} onClick={this.handleResultsClick}>
                  Итоговый протокол
                </Menu.Item>

                <Menu.Item key="vote-results" icon={<BarChartOutlined />} onClick={this.resultVoteClick}>
                  Результаты голосования
                </Menu.Item>

                <Menu.Item key="stream" icon={<VideoCameraOutlined />} onClick={this.handleStreamClick}>
                  Трансляция
                </Menu.Item>

                <Menu.Divider style={{ margin: '8px 0', borderColor: '#ccc' }} />

                <Menu.Item
                  key="status-label"
                  disabled
                  style={{
                    padding: '6px 12px 2px',
                    fontWeight: 500,
                    color: '#595959',
                    cursor: 'default',
                    fontSize: '14px',
                    lineHeight: '1.4'
                  }}
                >
                  Статус собрания:
                </Menu.Item>

                <Menu.Item
                  key="status-value"
                  disabled
                  style={{
                    padding: '2px 12px 6px',
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'default',
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#181818',
                    overflow: 'visible',
                    lineHeight: '1.4'
                  }}
                >
                  <span
                    className="status-dot"
                    style={{
                      backgroundColor: getStatusColor(meetings.status),
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      marginLeft: '5px',
                      marginRight: '8px',
                      boxShadow: '0 0 0 3px rgba(255, 165, 0, 0.2)'
                    }}
                  ></span>
                  {getStatusText(meetings.status)}
                </Menu.Item>
              </Menu>
            </div>

            <div style={{ flex: 1 }}>
              <Descriptions
                bordered
                column={2}
                size="middle"
                items={[
                  {
                    key: 'issuer',
                    label: 'Эмитент',
                    children: <Text strong>{issuer.full_name}</Text>,
                    span: 2,
                  },
                  {
                    key: 'address',
                    label: 'Место нахождения',
                    children: <Text strong>{issuer.address}</Text>,
                    span: 2,
                  },
                  {
                    key: 'meeting_name',
                    label: 'Описание собрания',
                    children: meeting_name,
                    span: 2,
                  },
                  {
                    key: 'location',
                    label: 'Место проведения / Почтовый адрес',
                    children: meeting_location,
                    span: 2,
                  },
                  {
                    key: 'registrar',
                    label: 'Регистратор',
                    children: <Text strong>Ведение реестров компаний</Text>,
                    span: 2,
                  },
                  {
                    key: 'decision_date',
                    label: 'Дата принятия решения',
                    children: formatDateOnly(decision_date),
                  },
                  {
                    key: 'deadline_date',
                    label: 'Дата окончания приёма',
                    children: formatDateOnly(deadline_date),
                  },
                  {
                    key: 'protocol_date',
                    label: 'Дата составления протокола',
                    children: formatDateOnly(protocol_date),
                  },
                  {
                    key: 'record_date',
                    label: 'Дата составления списка',
                    children: formatDateOnly(record_date),
                  },
                  {
                    key: 'meeting_date',
                    label: 'Дата собрания',
                    children: formatDateOnly(meeting_date),
                  },
                  {
                    key: 'checkin',
                    label: 'Начало регистрации',
                    children: formatDate(checkin),
                  },
                  {
                    key: 'meeting_open',
                    label: 'Начало собрания',
                    children: formatDate(meeting_open),
                  },
                  {
                    key: 'vote_counting',
                    label: 'Начало подсчёта голосов',
                    children: formatDate(vote_counting),
                  },
                  {
                    key: 'annual_or_unscheduled',
                    label: 'Вид собрания',
                    children: annual_or_unscheduled ? 'Годовое' : 'Внеочередное',
                  },
                  {
                    key: 'inter_or_extra_mural',
                    label: 'Форма собрания',
                    children: inter_or_extra_mural ? 'Очное' : 'Заочное',
                  },
                ]}
                labelStyle={{ fontWeight: 'bold', backgroundColor: '#fafafa' }}
                contentStyle={{ padding: '10px 12px' }}
                className="custom-descriptions"
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(VoteExtended);